import { render, staticRenderFns } from "./LandfillWasteComponent.vue?vue&type=template&id=76b803c3"
import script from "./LandfillWasteComponent.vue?vue&type=script&lang=js"
export * from "./LandfillWasteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports